import React from 'react'
import PropTypes from 'prop-types'
import { BUTTON_SIZES, BUTTON_TYPES } from 'shared/UI/Button'
import { Dialog } from 'shared/UI/Dialog'
import dynamicPosition from 'shared/hocs/dynamicPosition'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'
import includes from 'lodash/includes'
import values from 'lodash/values'

import './style.css.scss'

export const HORIZONTAL_POSITIONS = {
  insideLeft: 'inside-left',
  insideRight: 'inside-right',
  outsideLeft: 'outside-left',
  outsideRight: 'outside-right'
}

export const VERTICAL_POSITIONS = {
  insideTop: 'inside-top',
  insideBottom: 'inside-bottom',
  outsideTop: 'outside-top',
  outsideBottom: 'outside-bottom'
}

class InlineDialog extends React.Component {
  componentWillUnmount() {
    this.props.provideOutsideClickHandler(null)
    this.props.provideContainer(null)
  }

  setDialog = (dialogElement) => {
    const {
      setPositionClass, provideContainer, provideDialog,
      provideOutsideClickHandler, overflowContainerClass
    } = this.props

    setPositionClass(dialogElement, overflowContainerClass)
    provideContainer(dialogElement)
    provideOutsideClickHandler(this.handleOutSideClick)
    provideDialog && provideDialog(dialogElement)
  }

  handleOutSideClick = (e) => {
    const { onCancel, onClose, closeOnOutsideClick } = this.props

    if(!closeOnOutsideClick || this.isMatchingEmailComponent(e.target)){
      return
    }

    if(onCancel) {
      onCancel()
    }
    else if(onClose) {
      onClose(e)
    }
  }

  isMatchingEmailComponent = (el) => {
    while (!!el) {
      if(el.classList.contains('matching-users-component')) {
        return true
      }

      el = el.parentElement
    }

    return false
  }

  render() {
    const positionClasses = `${this.props.horizontalPosition || ''} ${this.props.verticalPosition || ''}`

    return (
      <Dialog
        onCancel={this.props.onCancel}
        cancelLabel={this.props.cancelLabel}
        onClose={this.props.onClose}
        closeLabel={this.props.closeLabel}
        onCustomButton={this.props.onCustomButton}
        customButtonLabel={this.props.customButtonLabel}
        buttonsSize={this.props.buttonsSize}
        showButtons={this.props.showButtons}
        className={`${this.props.className} ${positionClasses}`}
        provideDialog={this.setDialog}
        cancelButtonType={this.props.cancelButtonType}
        closeButtonType={this.props.closeButtonType}
        canClose={this.props.canClose}>
        {this.props.children}
      </Dialog>
    )
  }
}

InlineDialog.propTypes = {
  onCancel: PropTypes.func,
  cancelLabel: PropTypes.string,
  cancelButtonType: PropTypes.oneOf(values(BUTTON_TYPES)),
  onClose: PropTypes.func.isRequired,
  closeLabel: PropTypes.string,
  closeButtonType: PropTypes.oneOf(values(BUTTON_TYPES)),
  onCustomButton: PropTypes.func,
  customButtonLabel: PropTypes.string,
  buttonsSize: PropTypes.oneOf(values(BUTTON_SIZES)),
  horizontalPosition: PropTypes.oneOf(values(HORIZONTAL_POSITIONS)),
  verticalPosition: PropTypes.oneOf(values(VERTICAL_POSITIONS)),
  showButtons: PropTypes.bool,
  className: PropTypes.string,
  overflowContainerClass: PropTypes.string,
  provideDialog: PropTypes.func,
  closeOnOutsideClick: PropTypes.bool,
  enableDynamicPosition: PropTypes.bool,
  canClose: PropTypes.bool
}

InlineDialog.defaultProps = {
  closeOnOutsideClick: true,
  enableDynamicPosition: true
}

export default withOutsideClickHandler(dynamicPosition(InlineDialog))
